export const Steps = {
  verifyInformation: 1,
  checkForOrderErrors: 2,
  checkForInventoryErrors: 3,
  complete: 4,
};
export const PICKING_METHODS = {
  QUEUE: 'queue',
  BATCH: 'batch',
};
/**
 * @typedef {object} StatusProblemData
 * @property {boolean} isWarning
 * @property {string} problemDescription
 */

export const PICK_BATCH_STATUS = {
  READY_TO_PICK: 'ReadyToPick',
  PICKING: 'Picking',
  PICKED: 'Picked',
};
